<div class="box--white">
  <ion-row>
    <ion-col>
      <h2 (click)="openLegalInfo()">
        {{ (isStrategy ? 'sp.revamp.assetGraph.strategy.title' : 'sp.revamp.assetGraph.savings') | translate }}
        <ion-icon name="info-filled"></ion-icon>
      </h2>
      <div class="expected-box" [ngClass]="selectedChip ? 'orange' : 'blue'">
        <p class="title">
          {{
            (selectedChip ? 'sp.revamp.assetGraph.expected.total' : 'sp.revamp.assetGraph.expected.years')
              | translate: { estimatedPeriod: estimatedPeriod }
          }}
          <app-tooltip [trigger]="'expected-title'">
            <span [class.lowercase]="!isGerman()">
              {{ 'sp.revamp.infoTooltip.balancedRiskGross' | translate: { risk_level: ('STRATEGY.estimate.risk.' + riskLevel | translate) } }}
            </span>
          </app-tooltip>
        </p>
        <p class="funds" *ngIf="estimatedValues?.expected">
          <span class="currency">{{ currentAccount.currency }}</span>
          {{ (selectedChip ? estimatedValues.expectedWithout : estimatedValues.expected).toFixed(0) | thousand }}
        </p>
      </div>
      <div class="expected-box">
        <p class="title">{{ 'sp.revamp.assetGraph.expected.deposits' | translate: { estimatedPeriod: estimatedPeriod } }}</p>
        <p class="funds">
          <span class="currency">{{ currentAccount.currency }}</span>
          {{ getTotalDeposit() | thousand }}
        </p>
      </div>
      <div *ngIf="chartData?.data?.length" class="strategy-chart">
        <div class="tab-years">
          <div *ngFor="let option of [5, 10, 15, 20, 30]" class="tab" [class.active]="estimatedPeriod === option" (click)="changeEstimate(option)">
            {{ 'sp.revamp.assetGraph.y' | translate: { years: option } }}
          </div>
        </div>
        <app-range-chart
          [data]="chartData"
          [estimatedValues]="estimatedValues"
          [estimatedPeriod]="estimatedPeriod"
          [currency]="currentAccount.currency"
          [language]="language"
          [kind]="currentAccount?.kind"
          (selectedChip)="selectedChip = $event"
        ></app-range-chart>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <app-asset-deposit
        [appLocation]="appLocation"
        [currency]="currentAccount.currency"
        [newSavings]="strategyInfo?.monthly_investment"
        (changeValue)="onChangeValue($event)"
        (setDeposit)="onSetDeposit($event)"
      ></app-asset-deposit>
      <app-asset-social-proof
        [currency]="currentAccount.currency"
        [estimatedPeriod]="estimatedPeriod"
        [estimatedValues]="estimatedValues"
        [expectedPercentages]="expectedPercentages"
        [kind]="currentAccount.kind"
        [savingsPlanSocialProof]="savingsPlanSocialProof"
        (toggleDetails)="track($event)"
      ></app-asset-social-proof>
    </ion-col>
  </ion-row>
</div>
